export const getPaddingY = element => {
  const cs = getComputedStyle(element);
  return parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
};

export const getPaddingX = element => {
  const cs = getComputedStyle(element);
  return parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
};

export const getMarginY = element => {
  const cs = getComputedStyle(element);
  return parseFloat(cs.marginTop) + parseFloat(cs.marginBottom);
};

export const getContentWidth = element => {
  return element.clientWidth - getPaddingX(element);
};

export const getContentHeight = element => {
  return element.clientHeight - getPaddingY(element);
};

export const getEntireHeight = element => {
  return element.offsetHeight + getMarginY(element);
};
